import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/elements/follow-button.png")